/* esm.sh - rxjs@7.8.2/dist/esm/internal/util/NotFoundError */
import{createErrorClass as t}from"rxjs/dist/esm/internal/util/createErrorClass";var e=t(r=>function(o){r(this),this.name="NotFoundError",this.message=o});export{e as NotFoundError};
//# sourceMappingURL=NotFoundError.mjs.map